import { createContext, useContext, useReducer } from 'react';
import { OfficialDiaryDetailState, OfficialDiaryDetailReducer, ACTION_TYPES } from './official-diary-detail-reducer';
import { IOfficialDiaryDetailResponse } from '../../../../model/sdp/official-daily/response/official-diary-detail-response';
import { FileBase64 } from '../../../../model/file-base-64';

const OfficialDiaryDetailContext = createContext<OfficialDiaryDetailState | undefined>(undefined);
const OfficialDiaryDetailDispatchContext = createContext({} as any);

const OfficialDiaryDetailProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: OfficialDiaryDetailState = {
        officialDiaryDetail: {} as IOfficialDiaryDetailResponse,
        officialDiaryFile: {} as FileBase64,
        loading: false,
    };

    const [state, dispatch] = useReducer(OfficialDiaryDetailReducer, initialState);

    return (
        <OfficialDiaryDetailContext.Provider value={state}>
            <OfficialDiaryDetailDispatchContext.Provider value={dispatch}>
                {children}
            </OfficialDiaryDetailDispatchContext.Provider>
        </OfficialDiaryDetailContext.Provider>
    );
}

const useOfficialDiaryDetailState = () => {
    const context = useContext(OfficialDiaryDetailContext);
    if (context === undefined) {
        throw new Error('useOfficialDiaryDetailState must be used within a OfficialDiaryDetailProvider');
    }
    return context;
}

const useOfficialDiaryDetailDispatch = () => {
    const context = useContext(OfficialDiaryDetailDispatchContext);
    if (context === undefined) {
        throw new Error('useOfficialDiaryDetailDispatch must be used within a OfficialDiaryDetailProvider');
    }
    return context;
}

export { OfficialDiaryDetailProvider, useOfficialDiaryDetailDispatch, useOfficialDiaryDetailState, ACTION_TYPES };
